import { CmsPageView } from '../components/CmsPageView';

export default function TermsOfUsePage() {
  return <CmsPageView code="TERMS_CONDITIONS" fallbackTitle="Terms of Use" />;
}
